import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: 46,
    minWidth: 320
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingRight: 22
  },
  chip: {
    margin: 2,
    color: theme.palette.text.primary
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 350
    }
  }
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium
  };
}

const MultipleSelectChip = ({
  onChangeSelection,
  defaultSelectedValues,
  dataTestId,
  defaultOptionsToUse
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const defaultInit =
    defaultSelectedValues.length > 0 ? [...defaultSelectedValues] : [];
  const [selectedItems, setSelectedItems] = React.useState(defaultInit);
  const handleChange = (event) => {
    setSelectedItems(event.target.value);
    onChangeSelection([...event.target.value]);
  };
  return (
    <>
      <FormControl className={classes.formControl}>
        <Select
          data-test={dataTestId}
          variant="outlined"
          multiple
          fullWidth
          value={selectedItems}
          onChange={handleChange}
          input={<Input id="select-multiple-chip" />}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
          MenuProps={MenuProps}>
          {defaultOptionsToUse.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, selectedItems, theme)}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

MultipleSelectChip.propTypes = {
  onChangeSelection: PropTypes.func,
  defaultSelectedValues: PropTypes.array,
  defaultOptionsToUse: PropTypes.array.isRequired,
  dataTestId: PropTypes.string
};

export default MultipleSelectChip;
